// STYLES
import 'normalize.css'
import 'flexboxgrid'
import 'sass/fonts.scss'

import 'sass/header.scss'
import 'sass/footer.scss'
import 'sass/index.scss'
import 'sass/inner.scss'
import 'sass/404.scss'

import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
// import TweenMax from "gsap/TweenMax"

Vue.use(VueScrollTo)

new Vue({
  el: '#app',
  components: {

  },

  props: ['cRoute'],

  data() {
    return {
      modalOpened: false,
      modalTitle: '<strong>Пациент 1</strong>Х-образные кривые ноги',
      slides: pageSlides,
      // sliderCaptions: [
      //   'Операция по коррекции genu varum началась в 13:25.',
      //   '<strong>Пациент 1</strong> Х-образные кривые ноги',
      //   'Анестезирующий аппарат',
      // ],
      // sliderImages: [
      //   '/media/operation2.png',
      //   '/media/operation3.png',
      //   '/media/operation1.png',
      // ],
      slide: 0,
    }
  },

  mounted() {
    window.addEventListener('keydown', (e) => {
      if (this.modalOpened) {
        if (e.keyCode == 39) {
          this.nextSlide();
        } else if (e.keyCode == 37) {
          this.prevSlide();
        }
      }
    });
  },

  methods: {
    openModal(i) {
      this.slide = i;
      this.modalOpened = true;
    },
    prevSlide() {
      if (this.slide != 0) {
        --this.slide;
      }
    },
    nextSlide() {
      if (this.slide != this.slides.length - 1) {
        ++this.slide;
      }
    },
  }
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js